var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRateAddition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53352 2.91726L5.14473 1.30605L4.47985 0.641168L2.86864 2.25238L1.22747 0.611209L0.444369 1.39431L2.08554 3.03548L0.465327 4.65569L1.13021 5.32058L2.75042 3.70036L4.45892 5.40886L5.24202 4.62576L3.53352 2.91726Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateAddition);
export default __webpack_public_path__ + "static/media/rateAddition.6c11a378140e8dde72c91cd03a49a4bd.svg";
export { ForwardRef as ReactComponent };